module.exports = __webpack_public_path__ + "img/stock-photo_doctor-and-child.1987807c.jpg";